// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../assets/img/Checkbox.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ZavrsniRadovi_raniRazvojPrvaSekcija2__gV6dm {
  margin-top: 64px;
}
.ZavrsniRadovi_raniRazvojHeader__SoQIZ {
  color: #4d4d4d;
  font-family: Inter;
  font-size: 28px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  letter-spacing: -0.028px;
}
.ZavrsniRadovi_raniRazvojDescription__SGoLr {
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: -0.014px;
}
.ZavrsniRadovi_zavrsniWrapper__SU6qq {
  justify-content: center;
  width: 100%;
  gap: 16px;
  box-shadow: 0px 1px 2px 0px #1018280d;
  border: 1px solid #d1d9e2;
  background-color: #ffffff;
  padding: 16px 0px 16px 0px;
  margin-bottom: 24px;
  border-radius: 10px;
}
.ZavrsniRadovi_zavrsniWrapper__SU6qq,
.ZavrsniRadovi_checkboxLabel__dbpPw {
  display: flex;
  align-items: center;
}
.ZavrsniRadovi_label__ZFheE,
.ZavrsniRadovi_checkboxLabel__dbpPw,
.ZavrsniRadovi_raniRazvojDescription__SGoLr {
  color: #5f6d7e;
  font-family: Inter;
}
.ZavrsniRadovi_success__7ygQy {
  width: 24px;
  height: 24px;
}
.ZavrsniRadovi_label__ZFheE {
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: -0.001em;
  text-align: left;
}
.ZavrsniRadovi_checkboxLabel__dbpPw {
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  line-height: 17px;
  letter-spacing: 0em;
  text-align: left;
}
.ZavrsniRadovi_checkboxInput__B82SF {
  display: none;
}
.ZavrsniRadovi_checkboxInput__B82SF:checked + .ZavrsniRadovi_checkboxCustom__REbMr {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) center center no-repeat;
}
.ZavrsniRadovi_checkboxCustom__REbMr {
  width: 20px;
  height: 20px;
  border: 1px solid #e2e2e2;
  background-color: white;
  margin-right: 10px;
  border-radius: 4px;
}

@media screen and (max-width: 768px) {
  .ZavrsniRadovi_zavrsniWrapper__SU6qq {
    flex-direction: column !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/scenes/evidencija/components/ZavrsniRadovi/ZavrsniRadovi.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,wBAAwB;AAC1B;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;AAC1B;AACA;EACE,uBAAuB;EACvB,WAAW;EACX,SAAS;EACT,qCAAqC;EACrC,yBAAyB;EACzB,yBAAyB;EACzB,0BAA0B;EAC1B,mBAAmB;EACnB,mBAAmB;AACrB;AACA;;EAEE,aAAa;EACb,mBAAmB;AACrB;AACA;;;EAGE,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,2EAA8E;AAChF;AACA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE;IACE,iCAAiC;EACnC;AACF","sourcesContent":[".raniRazvojPrvaSekcija2 {\n  margin-top: 64px;\n}\n.raniRazvojHeader {\n  color: #4d4d4d;\n  font-family: Inter;\n  font-size: 28px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n  letter-spacing: -0.028px;\n}\n.raniRazvojDescription {\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  letter-spacing: -0.014px;\n}\n.zavrsniWrapper {\n  justify-content: center;\n  width: 100%;\n  gap: 16px;\n  box-shadow: 0px 1px 2px 0px #1018280d;\n  border: 1px solid #d1d9e2;\n  background-color: #ffffff;\n  padding: 16px 0px 16px 0px;\n  margin-bottom: 24px;\n  border-radius: 10px;\n}\n.zavrsniWrapper,\n.checkboxLabel {\n  display: flex;\n  align-items: center;\n}\n.label,\n.checkboxLabel,\n.raniRazvojDescription {\n  color: #5f6d7e;\n  font-family: Inter;\n}\n.success {\n  width: 24px;\n  height: 24px;\n}\n.label {\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 22px;\n  letter-spacing: -0.001em;\n  text-align: left;\n}\n.checkboxLabel {\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 17px;\n  letter-spacing: 0em;\n  text-align: left;\n}\n.checkboxInput {\n  display: none;\n}\n.checkboxInput:checked + .checkboxCustom {\n  background: url(\"../../../../assets/img/Checkbox.png\") center center no-repeat;\n}\n.checkboxCustom {\n  width: 20px;\n  height: 20px;\n  border: 1px solid #e2e2e2;\n  background-color: white;\n  margin-right: 10px;\n  border-radius: 4px;\n}\n\n@media screen and (max-width: 768px) {\n  .zavrsniWrapper {\n    flex-direction: column !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"raniRazvojPrvaSekcija2": `ZavrsniRadovi_raniRazvojPrvaSekcija2__gV6dm`,
	"raniRazvojHeader": `ZavrsniRadovi_raniRazvojHeader__SoQIZ`,
	"raniRazvojDescription": `ZavrsniRadovi_raniRazvojDescription__SGoLr`,
	"zavrsniWrapper": `ZavrsniRadovi_zavrsniWrapper__SU6qq`,
	"checkboxLabel": `ZavrsniRadovi_checkboxLabel__dbpPw`,
	"label": `ZavrsniRadovi_label__ZFheE`,
	"success": `ZavrsniRadovi_success__7ygQy`,
	"checkboxInput": `ZavrsniRadovi_checkboxInput__B82SF`,
	"checkboxCustom": `ZavrsniRadovi_checkboxCustom__REbMr`
};
export default ___CSS_LOADER_EXPORT___;
